const cards = [
  {
    tag: '独家',
    title: '幕后揭秘：某顶流演唱会假唱实锤全纪录',
    summary: '近日，51吃瓜网今日吃瓜收到多位现场观众投稿，指某当红歌手在最近一场万人演唱会上存在明显假唱行为。我们整理了现场多角度视频与音频对比分析，发现至少三首歌曲存在对口型嫌疑。',
    reads: '203.5万',
    time: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20concert%20stage%20atmosphere%20with%20soft%20coral%20and%20cream%20lighting%2C%20minimalist%20geometric%20composition%2C%20editorial%20news%20photography%20style%2C%20no%20text%20no%20people%20faces%2C%20clean%20modern%20aesthetic&width=720&height=480&seq=card-img-01-v1&orientation=landscape',
  },
  {
    tag: '追踪',
    title: '影视剧换角风波持续发酵，多方回应各执一词',
    summary: '备受关注的古装大剧临开机前突遭换角，原定男女主角双双被替换。51吃瓜最新了解到，片方与艺人团队之间存在严重的合同纠纷，双方各执一词，事件仍在持续发展中。',
    reads: '178.2万',
    time: '4小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20cream%20film%20set%20atmosphere%20with%20soft%20dramatic%20lighting%2C%20minimalist%20editorial%20composition%2C%20no%20text%20no%20people%20faces%2C%20clean%20cinematic%20aesthetic&width=720&height=480&seq=card-img-02-v1&orientation=landscape',
  },
  {
    tag: '热议',
    title: '网红直播翻车名场面合集，笑到停不下来',
    summary: '51每日吃瓜精选近期各大平台网红直播中最令人啼笑皆非的翻车瞬间，从带货翻车到才艺表演失误，每一段都堪称经典。瓜友们纷纷表示：这才是吃瓜的正确打开方式！',
    reads: '156.8万',
    time: '6小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20pink%20and%20cream%20streaming%20studio%20atmosphere%20with%20soft%20colorful%20lighting%2C%20minimalist%20geometric%20composition%2C%20editorial%20news%20style%2C%20no%20text%20no%20people%20faces%2C%20clean%20modern%20aesthetic&width=720&height=480&seq=card-img-03-v1&orientation=landscape',
  },
  {
    tag: '深扒',
    title: '明星社交账号小号被扒，画风与公开形象反差巨大',
    summary: '51吃瓜网今日吃瓜独家发现某一线明星疑似小号，内容风格与其阳光正面的公开形象形成巨大反差。该账号中包含大量争议言论和未公开照片，引发新一轮讨论热潮。',
    reads: '134.9万',
    time: '9小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20terracotta%20and%20cream%20social%20media%20atmosphere%20with%20soft%20phone%20screen%20glow%2C%20minimalist%20editorial%20composition%2C%20no%20text%20no%20people%20faces%2C%20clean%20modern%20aesthetic&width=720&height=480&seq=card-img-04-v1&orientation=landscape',
  },
  {
    tag: '爆料',
    title: '圈内人士匿名爆料：今年还有三个大瓜在路上',
    summary: '一位不愿透露姓名的资深圈内人士向51吃瓜网址独家透露，今年下半年娱乐圈还将有三个重量级大瓜蓄势待发，涉及顶流恋情、税务问题和合约纠纷，敬请关注51吃瓜今日吃瓜持续追踪。',
    reads: '112.4万',
    time: '11小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20cream%20mystery%20atmosphere%20with%20soft%20dramatic%20shadows%2C%20minimalist%20editorial%20composition%2C%20no%20text%20no%20people%20faces%2C%20clean%20modern%20news%20aesthetic&width=720&height=480&seq=card-img-05-v1&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜速递
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            最新最热的吃瓜资讯，图文并茂为你呈现精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.slice(0, 2).map((card, idx) => (
            <article
              key={idx}
              className="lg:col-span-1 bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative aspect-[3/2] bg-background-200 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.reads}
                  </span>
                  <span className="ml-auto">{card.time}</span>
                </div>
              </div>
            </article>
          ))}
          {cards.slice(2).map((card, idx) => {
            const actualIdx = idx + 2;
            return (
              <article
                key={actualIdx}
                className={`${actualIdx === 2 ? 'lg:col-span-2' : 'lg:col-span-1'} bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group`}
              >
                <div className={`flex ${actualIdx === 2 ? 'flex-col md:flex-row' : 'flex-col'}`}>
                  <div className={`relative bg-background-200 overflow-hidden ${actualIdx === 2 ? 'md:w-[45%] aspect-[3/2] md:aspect-auto' : 'aspect-[3/2]'}`}>
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={card.title}
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                        {card.tag}
                      </span>
                    </div>
                  </div>
                  <div className={`${actualIdx === 2 ? 'md:flex-1' : ''} p-4 md:p-5`}>
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {card.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-3">
                      {card.summary}
                    </p>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {card.reads}
                      </span>
                      <span className="ml-auto">{card.time}</span>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}